import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import "../App.css"; // Ensure this CSS file is included
import DataTable from "react-data-table-component";
import logo from "../assets/logo.png";
import dashboardIcon from "../assets/layout-grid.png";
import appointmentsIcon from "../assets/Tick Square.png";
import logoutIcon from "../assets/logout.png";
import userIcon from "../assets/user_avatar.png";

const Appointments = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("token");
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
      // Still clear local storage and navigate even if signOut fails
      localStorage.removeItem("token");
      navigate("/login");
    }
  };

  const stats = [
    { title: "Total Patient", value: 1, icon: "🧑‍⚕️" },
    { title: "No. Appointment", value: 1, icon: "📅" },
    { title: "Number of Delays", value: 0, icon: "⏳" },
    { title: "Total Doctors", value: 1, icon: "🩺" }
  ];

  const columns = [
    { name: "Line No.", selector: row => row.lineNo, sortable: true },
    { name: "Appt Made", selector: row => row.apptDate, sortable: true },
    { name: "Patient Name", selector: row => row.patientName, sortable: true },
    { name: "Physician", selector: row => row.physician, sortable: true },
    { name: "Appt Date and Time", selector: row => row.apptTime, sortable: true },
    { name: "Status", selector: row => row.status, sortable: true },
    { name: "Delay Time (Mins)", selector: row => row.delayTime, sortable: true }
  ];

  const data = [
    { lineNo: "01", apptDate: "10/02/25", patientName: "Jane Doe", physician: "Dr. Sarah Johnson", apptTime: "10/11/25 | 08:00 PM", status: "Scheduled", delayTime: 0 },
   ];

  return (
    <div className="appointments-container">
      {/* Sidebar */}
      <div className="sidebar">
        <img src={logo} alt="Timely Logo" className="logo-image" />
        <div className="user-profile">
          <div className="user-info">
            <h3>Kevin Beers</h3>
            <p>Support Team</p>
          </div>
        </div>
        <nav>
          <a href="/dashboard">
            <img src={dashboardIcon} alt="Dashboard" className="menu-icon" />
            Dashboard
          </a>
          <a href="/appointments" className="active">
            <img src={appointmentsIcon} alt="Appointments" className="menu-icon" />
            Appointments
          </a>
          <a href="/users">
            <img src={userIcon} alt="Users" className="menu-icon" />
            Users
          </a>
          <a href="/doctors">
            <span className="menu-icon" style={{ fontSize: "24px" }}>👨‍⚕️</span>
            Doctors
          </a>
          <a href="/" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
            <img src={logoutIcon} alt="Log Out" className="menu-icon" />
            Log Out
          </a>
        </nav>
      </div>

      {/* Main Content */}
      <div className="appointments-page">
        
        <h1 className="dashboard-title">Appointments</h1>

        {/* Stats Cards */}
        <div className="stats-cards">
          {stats.map((stat, index) => (
            <div key={index} className="card">
              <span className="icon">{stat.icon}</span>
              <h3>{stat.value}</h3>
              <p>{stat.title}</p>
            </div>
          ))}
        </div>

        {/* Appointments Table */}
        <div className="appointments-table">
          <DataTable
            columns={columns}
            data={data}
            pagination
            highlightOnHover
            striped
            responsive
          />
        </div>
      </div>
    </div>
  );
};

export default Appointments;
